'use client';

import { useLayoutEffect, ReactNode } from 'react';
import { useBreadcrumb } from '@/contexts/BreadcrumbContext';
import type { BreadcrumbItem } from '@/types/breadcrumbs';

interface EventBreadcrumbProviderProps {
  breadcrumbs: BreadcrumbItem[];
  children: ReactNode;
}

export function EventBreadcrumbProvider({ breadcrumbs, children }: EventBreadcrumbProviderProps) {
  const { setCustomBreadcrumbs } = useBreadcrumb();

  // Use useLayoutEffect to set breadcrumbs synchronously before paint
  useLayoutEffect(() => {
    setCustomBreadcrumbs(breadcrumbs);
    return () => setCustomBreadcrumbs(null); // Clean up on unmount
  }, [breadcrumbs, setCustomBreadcrumbs]);

  return <>{children}</>;
}
